<template>
  <div :class="['hamburger-box', openSidebar ? '' : 'rotate']"  @click="toggleSideBar">
    <svg-icon iconClass="hamburger-menu" className="hamburger-menu"></svg-icon>
  </div>
</template>

<script>
export default {
  computed: {
    openSidebar() {
      return this.$store.state.app.openSidebar
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar")
    }
  }
}
</script>

<style lang="scss" scoped>
.hamburger-box{
  cursor: pointer;
  transition: all 0.36s;
  color: rgba(255,255,255, 0.8);
  &.rotate{
    transform: rotate(180deg);
  }
  .hamburger-menu{
    display: inline-block;
    vertical-align: middle;
    width: 26px;
    height: 26px;
  }
}
</style>